module.exports = __webpack_public_path__ + "statics/img/hero-right.79cdcca1.png";